/* eslint no-undef: 'off' */
import $ from "jquery";

const register_account = (data, args = {}) => {
  const ajax = themeObj.registerAccount;
  data = { ...data, ...ajax };
  return $.ajax({
    url: themeObj.ajaxUrl,
    method: "POST",
    data: data,
    ...args,
  });
};

const login_account = (email, password, args = {}) => {
  const ajax = themeObj.loginAccount;
  return $.ajax({
    url: themeObj.ajaxUrl,
    method: "POST",
    ...args,
    data: {
      email: email,
      password: password,
      ...ajax,
      ...args.data,
    },
  });
};

const forget_password = (email, args = {}) => {
  const ajax = themeObj.forgetPassword;
  
  return $.ajax({
    url: themeObj.ajaxUrl,
    method: 'POST',
    ...args,
    data: {
      ...ajax,
      email,
      ...args.data
    }
  });
}

export default { register_account, login_account, forget_password };
